import { styled } from '@mui/material/styles';
import { Grid } from '@mui/material';

const StyledGrid = styled(Grid)(({ theme }) => ({
  '&.PCLGridContainer': {
    '& .MuiGrid-item': {
      [theme.breakpoints.down('lg')]: {
        paddingTop: theme.spacing(6),
        '&:first-child': {
          paddingTop: theme.spacing(3),
        },
      },
    },
  },
}));

export default StyledGrid;
